import { render } from "./AddTender.vue?vue&type=template&id=59486d41&scoped=true"
import script from "./AddTender.vue?vue&type=script&lang=js"
export * from "./AddTender.vue?vue&type=script&lang=js"

import "./AddTender.vue?vue&type=style&index=0&id=59486d41&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59486d41"]])

export default __exports__